import React from 'react';
import { Row, Col, Modal, ModalHeader, ModalBody, Button, Alert } from 'reactstrap';
import { AvForm, AvField } from 'availity-reactstrap-validation';
import { Translate, translate, Storage } from 'react-jhipster';
import { handleGetInfo, reset } from '../../register/register.reducer';
import { IRootState } from 'app/shared/reducers';
import { connect } from 'react-redux';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import { MSSP_PROVIDER, LINK_TERM_OF_USE } from 'app/config/constants';

export interface IAuthAddSimProps extends StateProps, DispatchProps {
  modalShow: boolean;
  handleClose: Function;
  showModalCertInfo: Function;
}

export interface IAuthAddSimPropsState {
  visible: boolean;
  color: string;
  message: string;
  disableButtonReg: boolean;
  isDropDownOpen: boolean;
  strImg: string;
  name: string;
}

const imgVina = require('app/images/vinaphone.png');
const imgViettel = require('app/images/viettel.svg');
const imgBCY = require('app/images/vgca.svg');
const imgMobi = require('app/images/imgMobi.jpeg');

const nameVina = 'Sim PKI Vinaphone';
const nameViettel = 'Sim PKI Viettel';
const nameBCY = 'Sim PKI Ban Cơ yếu Chính phủ';
const nameMobi = 'Sim PKI Mobifone';

var arrName = [
  { id: '1', name: nameVina, image: imgVina },
  { id: '2', name: nameViettel, image: imgViettel },
  { id: '3', name: nameBCY, image: imgBCY },
  { id: '4', name: nameMobi, image: imgMobi }
];
export class AuthAddSim extends React.Component<IAuthAddSimProps> {
  state: IAuthAddSimPropsState = {
    visible: false,
    color: 'info',
    message: '',
    disableButtonReg: false,
    isDropDownOpen: false,
    strImg: imgVina,
    name: MSSP_PROVIDER.VINA
  };

  componentWillReceiveProps(nextProps) {
    if (this.props.infoCert !== nextProps.infoCert) {
      const { infoCert } = nextProps;
      //console.log("infoCert: " + JSON.stringify(infoCert));
      if (infoCert && infoCert.status === 'SUCCESS') {
        Storage.session.set('type', 'Sim');
        Storage.session.set('provider', this.state.name);
        //Storage.session.set('certInfo', infoCert);
        this.props.showModalCertInfo();
        window['showHideModal']('show');
        this.setState({
          disableButtonReg: false
        });
      } else if (infoCert && infoCert.status) {
        this.setState({
          disableButtonReg: false,
          visible: true,
          color: 'danger',
          message: infoCert.message
        });
        let timerId = setTimeout(() => {
          this.setState({
            visible: false
          });
        }, 3000);
      }
    }
  }

  componentWillUnmount() {
    //this.props.reset();
  }

  handleValidSubmit = (event, values) => {
    this.onDismiss();
    this.props.handleGetInfo(values.mobile.trim(), this.state.name);
    this.setState({
      disableButtonReg: true,
      visible: true,
      color: 'info',
      message: translate('global.messages.info.simPki.message')
    });
  };

  onDismiss = () => {
    this.setState({ visible: false });
  };

  handleToggle = () => {
    this.setState({
      disableButtonReg: false,
      visible: false
    });
    this.props.handleClose();
  };

  toggle = () => {
    this.setState({
      isDropDownOpen: !this.state.isDropDownOpen
    });
  };

  clickItemDropDown = e => {
    switch (e.currentTarget.textContent) {
      case nameVina:
        this.setState({
          strImg: imgVina,
          name: MSSP_PROVIDER.VINA
        });
        break;

      case nameViettel:
        this.setState({
          strImg: imgViettel,
          name: MSSP_PROVIDER.VIETTEL
        });
        break;

      case nameBCY:
        this.setState({
          strImg: imgBCY,
          name: MSSP_PROVIDER.BCY
        });
        break;

      case nameMobi:
        this.setState({
          strImg: imgMobi,
          name: MSSP_PROVIDER.MOBI
        });
        break;

      default:
        break;
    }
  };

  render() {
    return (
      <div>
        <Modal
          className="hide-border-bottom-modal"
          isOpen={this.props.modalShow}
          toggle={this.handleToggle}
          backdrop="static"
          centered={window.location === window.parent.location}
        >
          <ModalHeader toggle={this.handleToggle} />
          <ModalBody className="padding-modal-body">
            <Row className="justify-content-center bodyModal">
              <Col md="12">
                <AvForm id="register-form" onValidSubmit={this.handleValidSubmit}>
                  <div className="huong-dan-dk-sim">
                    <div className="title">Hướng dẫn đăng ký bằng Sim ký số</div>
                    <Alert id="myAlert" color={this.state.color} isOpen={this.state.visible} toggle={this.onDismiss}>
                      {this.state.message}
                    </Alert>
                    <div className="steps">
                      <div className="li">
                        <p>1. Nhập số điện thoại của Sim ký số.</p>
                        {/* <AvField
                          name="mobile"
                          validate={{
                            required: { value: true, errorMessage: translate('global.messages.validate.mobile.required') },
                            number: { value: true, errorMessage: translate('global.messages.validate.mobile.invalid') }
                          }}
                        /> */}
                        <Row style={{ flex: 1 }}>
                          <Col style={{ flex: 0.3 }}>
                            <Dropdown isOpen={this.state.isDropDownOpen} toggle={this.toggle}>
                              <DropdownToggle className="drop-down" caret>
                                <img className="icon-select-home-network" src={this.state.strImg} />
                              </DropdownToggle>
                              <DropdownMenu>
                                {arrName.map(item => (
                                  <DropdownItem
                                    className="drop-down-item"
                                    style={{ width: 'max-content' }}
                                    key={item.id}
                                    onClick={this.clickItemDropDown}
                                  >
                                    <img className="icon-home-network-item" src={item.image} />
                                    <label>{item.name}</label>
                                  </DropdownItem>
                                ))}
                              </DropdownMenu>
                            </Dropdown>
                          </Col>

                          <Col style={{ flex: 0.7 }}>
                            <AvField
                              style={{ marginLeft: '-15px' }}
                              name="mobile"
                              placeholder={translate('global.form.mobile.placeholder')}
                              validate={{
                                required: { value: true, errorMessage: translate('global.messages.validate.mobile.required') },
                                number: { value: true, errorMessage: translate('global.messages.validate.mobile.invalid') }
                              }}
                            />
                          </Col>
                        </Row>
                      </div>
                      <div className="li">2. Gắn thẻ Sim và bật điện thoại để sẵn sàng xác nhận Sim ký số</div>
                      <div className="li">
                        3. Bằng cách nhấp vào Đăng ký, bạn đồng ý với{' '}
                        <a className="link" href={LINK_TERM_OF_USE} target="_blank">
                          Điều khoản, Chính sách chia sẻ thông tin
                        </a>{' '}
                        của chúng tôi
                      </div>
                    </div>
                  </div>
                  <Button className="btn-register" type="submit" disabled={this.state.disableButtonReg} block>
                    <Translate contentKey="register.form.button">Register</Translate>
                  </Button>
                </AvForm>
              </Col>
            </Row>
          </ModalBody>
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = (storeState: IRootState) => ({
  infoCert: storeState.register.infoCert
});

const mapDispatchToProps = { handleGetInfo, reset };
type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AuthAddSim);
